/* Action types with TypeScript type declaration */
export const SIGNIN_SUCCESS = 'rpb2b-react/signin/SIGNIN_SUCCESS';
export type SIGNIN_SUCCESS = typeof SIGNIN_SUCCESS;

export const SET_SELECT_ACCOUNT = 'rpb2b-react/signin/SET_SELECT_ACCOUNT';
export type SET_SELECT_ACCOUNT = typeof SET_SELECT_ACCOUNT;

export const SET_SHOULD_VERIFY = 'rpb2b-react/signin/SET_SHOULD_VERIFY';
export type SET_SHOULD_VERIFY = typeof SET_SHOULD_VERIFY;

export const SET_SHOULD_UPDATE_INFO =
  'rpb2b-react/signin/SET_SHOULD_UPDATE_INFO';
export type SET_SHOULD_UPDATE_INFO = typeof SET_SHOULD_UPDATE_INFO;

export const SET_TWO_STEP_AUTH = 'rpb2b-react/signin/SET_TWO_STEP_AUTH';
export type SET_TWO_STEP_AUTH = typeof SET_TWO_STEP_AUTH;

export const CHANGE_ACTIVE_ACCOUNT = 'rpb2b-react/signin/CHANGE_ACTIVE_ACCOUNT';
export type CHANGE_ACTIVE_ACCOUNT = typeof CHANGE_ACTIVE_ACCOUNT;

export const SET_ACTIVE_ACCOUNT_COUNTRY =
  'rpb2b-react/signin/SET_ACTIVE_ACCOUNT_COUNTRY';
export type SET_ACTIVE_ACCOUNT_COUNTRY = typeof SET_ACTIVE_ACCOUNT_COUNTRY;

export const ACTIVE_ACCOUNT_HAS_CHANGED =
  'rpb2b-react/signin/ACTIVE_ACCOUNT_HAS_CHANGED';
export type ACTIVE_ACCOUNT_HAS_CHANGED = typeof ACTIVE_ACCOUNT_HAS_CHANGED;

export const SIGNIN_ERROR = 'rpb2b-react/signin/SIGNIN_ERROR';
export type SIGNIN_ERROR = typeof SIGNIN_ERROR;

export const SIGNIN_PENDING = 'rpb2b-react/signin/SIGNIN_PENDING';
export type SIGNIN_PENDING = typeof SIGNIN_PENDING;

export const SIGNIN = 'rpb2b-react/signin/LOGIN';
export type SIGNIN = typeof SIGNIN;

export const SIGNOUT = 'rpb2b-react/signin/LOGOUT';
export type SIGNOUT = typeof SIGNOUT;

export const SET_SAMSUNG_USER_SIGN_IN =
  'rpb2b-react/signin/SAMSUNG_USER_SINGIN';
export type SET_SAMSUNG_USER_SIGN_IN = typeof SET_SAMSUNG_USER_SIGN_IN;

export default {
  SIGNIN,
  SIGNOUT,
  SIGNIN_SUCCESS,
  SIGNIN_ERROR,
  SIGNIN_PENDING,
  SET_SELECT_ACCOUNT,
  SET_TWO_STEP_AUTH,
  CHANGE_ACTIVE_ACCOUNT,
  ACTIVE_ACCOUNT_HAS_CHANGED,
  SET_SHOULD_VERIFY,
  SET_SHOULD_UPDATE_INFO,
  SET_ACTIVE_ACCOUNT_COUNTRY,
  SET_SAMSUNG_USER_SIGN_IN
};
